module.exports = __webpack_public_path__ + "img/devices.ff72d01b.svg";